let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '申请人手机号码',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '接受发票邮箱',
        props: 'custEmail',
        minWidth: 200,
        sortable:'custom',
    },
    {
        label: '申请时间',
        props: 'createdWhen',
        minWidth: 200,
        sortable:'custom',
    },
    {
        label: '开票时间',
        props: 'invoicTime',
        minWidth: 200,
        sortable:'custom',
    },
    {
        label: '订单金额（实付）',
        props: 'orderAmounts',
        minWidth: 200,
        sortable:'custom',
    },
    {
        label: '开票金额',
        props: 'invoicableAmount',
        minWidth: 120,
        sortable:'custom',
    },
    {
        label: '开票状态',
        props: 'invoicingStatus',
        minWidth: 200,
        sortable:'custom',
        formatter: function formatter(row, column, cellValue, index) {
            if (row.invoicingStatus == '03') {
                return '已开票'
            } {
                return '未开票'
            }
        }
    },
    {
        label: '发票类型',
        props: 'invoicingType',
        minWidth: 180,
        sortable:'custom',
        formatter: function formatter(row, column, cellValue, index) {
            if (row.invoicingType == '01') {
                return '普通发票'
            }
            else if (row.invoicingType == '02') {
                return '增值税专用发票'
            } {
                return ''
            }
        }
    },
    {
        label: '抬头类型',
        props: 'invoicingHeaderStatus',
        minWidth: 180,
        sortable:'custom',
        formatter: function formatter(row, column, cellValue, index) {
            if (row.invoicingHeaderStatus == '01') {
                return '个人'
            }
            else if (row.invoicingHeaderStatus == '02') {
                return '企业'
            } {
                return ''
            }
        }
    },
    {
        label: '公司名称',
        props: 'enterpriseName',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '税号',
        props: 'taxNumber',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '开户行',
        props: 'depositBank',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '银行账号',
        props: 'bankAccount',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '注册地址',
        props: 'businessAddress',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '注册电话',
        props: 'businessPhone',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '订单编号',
        props: 'orderNo',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '桩编号',
        props: 'pileCode',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '电站',
        props: 'stationName',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '开始充电时间',
        props: 'beginTime',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '结束充电时间',
        props: 'endTime',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '充电时长',
        props: 'chargeMin',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '单价',
        props: 'ttlVal',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '充电金额（预充）',
        props: 'prePayFee',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '订单金额（实充）',
        props: 'actPayFee',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '电费',
        props: 'elecFee',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '服务费',
        props: 'servFee',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '支付金额',
        props: 'payFee',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '支付时间',
        props: 'payWhen',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '支付流水号',
        props: 'payWalletList',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '退款金额',
        props: 'actInExpAmount',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '退款时间',
        props: 'transactionSucceedTime',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '退款流水号',
        props: 'walletListNo',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '钱包余额支付',
        props: 'walletBalancePay',
        minWidth: 180,
        sortable:'custom',
    },
    {
        label: '度电支付',
        props: 'electricityPay',
        minWidth: 180,
        sortable:'custom',
    },
];

// // 列表展示项
// pageConfig.detailTableColumns = [
//     {
//         label: '合计订单',
//         props: 'mobile',
//         minWidth: 200,
//     },
//     {
//         label: '桩到家订单（元）',
//         props: 'registerDate',
//         minWidth: 200,
//     },
//     {
//         label: '自营订单（元）',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '充电量（kW·h)',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '用户量（人）',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '订单量（单）',
//         props: 'custDto',
//         minWidth: 120,
//     },
//     {
//         label: '服务费（元）',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '实际收入（元）',
//         props: 'custDto',
//         minWidth: 180,
//     },
// ];


// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理',
},
{
    type: 'title',
    name: '开票订单流水'
},];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
    herderStyle:{background:'#FAFAFA',color: '#8F9BB3',fontSize: '14px',fontFamily:'PingFangSC-Medium, PingFang SC'}
};

// 列表-表格属性
pageConfig.detailTableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [2,3,4,5,10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'dealerDetail',
};

// 路由
pageConfig.listRouter = 'dealerManageList';

pageConfig.reportRouter = 'dealerReportDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '运营商管理',
    router: 'dealerManageList'
},
{
    type: 'title',
    name: '运营商详情',
}];

pageConfig.addRuleArr = ['dealName','dealAbbrName','organizeNo','contactName','contactPhone','bankCard','bankName','bankCode'];

pageConfig.editRuleArr = ['dealName','dealAbbrName','organizeNo','contactName','contactPhone'];

pageConfig.formRules = {
    dealName: [{
        required: true,
        message: '请填写公司名称',
        trigger: 'blur'
    }],
    dealAbbrName: [{
        required: true,
        message: '请填写公司简称',
        trigger: 'blur'
    }],
    organizeNo: [{
        required: true,
        message: '请填写社会统一组织机构代码',
        trigger: 'blur'
    }],
    contactName: [{
        required: true,
        message: '请填写公司联系人1',
        trigger: 'blur'
    }],
    contactPhone: [{
        required: true,
        message: '请填写联系方式',
        trigger: 'blur'
    }],
    bankCard: [{
        required: true,
        message: '请填写收款方银行卡号',
        trigger: 'blur'
    }],
    bankName: [{
        required: true,
        message: '请填写收款方用户名',
        trigger: 'blur'
    }],

    bankCode: [{
        required: true,
        message: '请填开户行编号',
        trigger: 'blur'
    }],
    serviceTel: [{
        required: true,
        message: '请填写客服电话',
        trigger: 'blur'
    }],
    turnoverMerchantCode: [{
        required: true,
        message: '请填写微信商户编号',
        trigger: 'blur'
    }],
    wxMerchantName: [{
        required: true,
        message: '请填写微信商户全称',
        trigger: 'blur'
    }],
};


export default pageConfig;